export default __webpack_public_path__ + "static/media/mockup-itap.5622453a.png";